import axiosInstance from '../api/axiosInstance';

const getMedineerTestPackages = async ({
    pageNumber = 1,
    pageSize = 4,
    specificCourseIds = null,
}) => {
    const response = await axiosInstance.get(
        '/api/Courses/getCourses',
        {
            params: {
                pageNumber,
                pageSize,
                contentFilter: 0,
                contentCuratorIds: null,
                objective: null,
                isMedineerLogin: true,
                specificCourseIds,
            },
        }
    );

    // backend returns .NET style response
    return response?.data?.$values || [];
};

export default getMedineerTestPackages;
